export const getSearchObjectFromUrlParams = (urlParams) => Object.fromEntries(
  Array.from(urlParams).map(([key, value]) => [
    key,
    value === '' ? '' : value,
  ]),
);
